module.exports = __webpack_public_path__ + "static/media/Ornate1_After.4a4deea7.jpg";